export default __webpack_public_path__ + "static/media/ramadan.c67e7e30.jpg";